<template>
<v-container class="fill-height data-container" fluid>

    <v-stepper class="stepper" v-model="currentStep">
        <v-stepper-header style="height: 50px;">
            <v-stepper-step class="stepper-step" step="1" :complete="currentStep > 1" editable :color="'#c42111'" :rules="[() => validation.alarmStepForm($refs.alarmParamsForm)]">Alarm Parameters</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step class="stepper-step" step="2" :complete="currentStep > 2" editable :color="'#c42111'" :rules="[() => validation.alarmStepForm($refs.alarmModForm)]">Modifications</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step class="stepper-step" step="3" :complete="currentStep > 3" editable :color="'#c42111'" :rules="[() => validation.alarmStepForm($refs.ruleDetailsForm)]">Rule Details</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="stepper-content-container">
            <v-stepper-content :step="1" class="stepper-content">
            <v-form ref="alarmParamsForm" class="fill-height" :lazy-validation="true" v-model="paramsFormValid">
                <v-row dense :style="{overflow: 'auto'}">
                    <v-col cols="12" md="6" xl="6">
                        <v-text-field label="Office" color="#c42111" v-model="$props.alarmMod.modif_office" />
                    </v-col>
                    <v-col cols="12" md="6" xl="6">
                        <v-text-field label="Location" color="#c42111" v-model="$props.alarmMod.modif_location" />
                    </v-col>
                    
                    <v-col cols="12" md="12" xl="12">
                        <v-select label="Locale" v-model="locale" multiple color="#c42111" :items="$props.alarmModResources.locale_list">
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index < 1">{{ `${item}, ` }}</span>
                                <span v-if="index === 1">{{ `${item}` }}</span>
                                <span v-if="index === 2" class="grey--text caption">(+{{ locale.length - 2 }} others)</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="12" xl="12">
                        <v-text-field label="Description" color="#c42111" v-model="$props.alarmMod.modif_code" />
                    </v-col>

                    <v-col cols="12" sm="6" md="6" xl="6">
                        <v-text-field type="number" label="Repeats" color="#c42111" v-model="$props.alarmMod.modif_repeats" :rules="[validation.nonNegInteger($props.alarmMod.modif_repeats)]" />
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="6">
                        <v-text-field type="number" label="Within" suffix="minutes" color="#c42111" v-model="$props.alarmMod.modif_within" :rules="[validation.nonNegInteger($props.alarmMod.modif_within)]" />
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="6">
                        <v-text-field type="number" label="Occurs" color="#c42111" v-model="$props.alarmMod.modif_bounce_times" :rules="[validation.nonNegInteger($props.alarmMod.modif_bounce_times)]" />
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="6">
                        <v-text-field type="number" label="Within" suffix="minutes" color="#c42111" v-model="$props.alarmMod.modif_bounce_minutes" :rules="[validation.nonNegInteger($props.alarmMod.modif_bounce_minutes)]" />
                    </v-col>

                    <v-col cols="12" sm="6" md="6" xl="3">
                        <v-menu v-model="editAfterThisTime" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field clearable v-model="$props.alarmMod.modif_after_time" color="#c42111" label="After This Time" prepend-icon="access_time" readonly v-on="on" :rules="[$store.state.validationFuncs.requiredIf($props.alarmMod.modif_after_time, $props.alarmMod.modif_before_time, 'After This Time')]"></v-text-field>
                            </template>
                            <v-time-picker v-model="$props.alarmMod.modif_after_time" color="#c42111" :hourOnly="false" :format="'24hr'" use-seconds scrollable />
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="3">
                        <v-menu v-model="editBeforeThisTime" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field clearable v-model="$props.alarmMod.modif_before_time" color="#c42111" label="Before This Time" prepend-icon="access_time" readonly v-on="on" :rules="[$store.state.validationFuncs.requiredIf($props.alarmMod.modif_before_time, $props.alarmMod.modif_after_time, 'Before This Time')]"></v-text-field>
                            </template>
                            <v-time-picker v-model="$props.alarmMod.modif_before_time" color="#c42111" :hourOnly="false" :format="'24hr'" use-seconds scrollable />
                        </v-menu>
                    </v-col>

                    <v-col cols="12" md="6" xl="3">
                        <v-select label="Severity" multiple v-model="severity" color="#c42111" :items="severityTypes" />
                    </v-col>
                    <!-- <v-col cols="12" md="6" xl="3">
                        <v-select label="Facility Type" v-model="$props.alarmMod.modif_facility_type" color="#c42111" :items="facilityTypes" />
                    </v-col> -->
                </v-row>

                <v-row dense>
                    <div>
                        <span class="week-day-label ml-1 mt-2">Days of Week</span>
                        <v-checkbox class="week-day" v-model="$props.alarmMod.modif_days_sun" label="Sunday" color="#c42111"></v-checkbox>
                        <v-checkbox class="week-day" v-model="$props.alarmMod.modif_days_mon" label="Monday" color="#c42111"></v-checkbox>
                        <v-checkbox class="week-day" v-model="$props.alarmMod.modif_days_tue" label="Tuesday" color="#c42111"></v-checkbox>
                        <v-checkbox class="week-day" v-model="$props.alarmMod.modif_days_wed" label="Wednesday" color="#c42111"></v-checkbox>
                        <v-checkbox class="week-day" v-model="$props.alarmMod.modif_days_thu" label="Thursday" color="#c42111"></v-checkbox>
                        <v-checkbox class="week-day" v-model="$props.alarmMod.modif_days_fri" label="Friday" color="#c42111"></v-checkbox>
                        <v-checkbox class="week-day" v-model="$props.alarmMod.modif_days_sat" label="Saturday" color="#c42111"></v-checkbox>
                    </div>
                </v-row>
            </v-form>
            </v-stepper-content>

            <v-stepper-content :step="2" class="stepper-content">
            <v-form ref="alarmModForm" class="fill-height" :lazy-validation="true" v-model="modFormValid">
                <v-row dense>
                    <v-col cols="12" md="3">
                        <v-checkbox v-model="$props.alarmMod.modif_disregard" label="Disregard" color="#c42111" :rules="[validation.modRequired($props.alarmMod)]"></v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="6" md="3">
                        <v-select label="Change severity to" v-model="$props.alarmMod.modif_change_severity" color="#c42111" :items="severityTypes" clearable :rules="[validation.modRequired($props.alarmMod)]" />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="6" md="3">
                        <v-text-field label="Change text to" color="#c42111" v-model="$props.alarmMod.modif_text" :rules="[validation.modRequired($props.alarmMod)]" />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" md="3">
                        <v-checkbox v-model="$props.alarmMod.modif_clear_iff_acked" label="Allow device to clear only if acked" color="#c42111" :rules="[validation.modRequired($props.alarmMod)]"></v-checkbox>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" md="3">
                        <v-checkbox v-model="$props.alarmMod.modif_clear_never" label="Never allow device to clear" color="#c42111" :rules="[validation.modRequired($props.alarmMod)]"></v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" md="3">
                        <v-text-field label="Clear after" color="#c42111" v-model="$props.alarmMod.modif_clear_after_min" suffix="minutes" :rules="[validation.nonNegInteger($props.alarmMod.modif_clear_after_min), validation.modRequired($props.alarmMod)]" />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" md="3">
                        <v-checkbox v-model="$props.alarmMod.modif_service_affecting" label="Mark as service affecting" color="#c42111" :rules="[validation.modRequired($props.alarmMod)]"></v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" md="3">
                        <v-text-field label="Shakeout Delay" color="#c42111" v-model="$props.alarmMod.modif_shakeout" suffix="minutes" :rules="[validation.nonNegInteger($props.alarmMod.modif_shakeout), validation.modRequired($props.alarmMod)]" />
                    </v-col>
                </v-row>
            </v-form>
            </v-stepper-content>

            <v-stepper-content :step="3" class="stepper-content">
            <v-form ref="ruleDetailsForm" class="fill-height" :lazy-validation="true" v-model="detailsFormValid">
                <v-container class="fill-height" fluid>
                    <v-row dense>
                        <v-col cols="12">
                            <v-radio-group v-model="timeLimited" row @change="clearDates">
                                <v-radio label="Always Active" :value="false" color="#c42111"></v-radio>
                                <v-radio label="Time-Limited" :value="true" color="#c42111"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-datetime-picker label="Active From" :textFieldProps="tfProps" v-model="$props.alarmMod.modif_active_starting" :disabled="!timeLimited" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" v-if="showTimeLimited" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-datetime-picker label="Active Until" :textFieldProps="tfProps" v-model="$props.alarmMod.modif_active_until" :disabled="!timeLimited" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" v-if="showTimeLimited" />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" md="6" xl="3">
                            <v-checkbox v-model="$props.alarmMod.modif_stop_if_matches" label="End processing if this rule matches?" color="#c42111"></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea v-model="$props.alarmMod.modif_doc" outlined label="Rule Documentation" color="#c42111"></v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            </v-stepper-content>
            
        </v-stepper-items>
    </v-stepper>

    <v-btn class="mt-3 mr-3" color="#c42111" @click="okClicked" :disabled="$props.lockSave">Ok</v-btn>
    <v-btn class="mt-3 mr-3" color="#c42111" @click="$emit('cancel')">Cancel</v-btn>
    <v-btn class="mt-3 ml-9" color="#c42111" @click="$store.commit('openWikiHelp', 'TecAlert/AlarmModifications')">Help</v-btn>

</v-container>
</template>

<script>
export default {
    name: 'AlarmModificationsEdit',
    props: ['alarmMod', 'alarmModResources', 'lockSave'],
    components: {
    },
    data: () => ({
        paramsFormValid: true,
        modFormValid: true,
        detailsFormValid: true,
        currentStep: 1,
        editAfterThisTime: false,
        editBeforeThisTime: false,
        timeLimited: false,
        facilityTypes: ['[any]', 'switch', 'cell', 'transmission'],
        severityTypes: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL'],
        validation: {
            nonNegInteger: (value) => ((value.toString().indexOf('.') === -1) && (value.toString().indexOf('e') === -1) && (value.toString().indexOf('-') === -1) && parseInt(Number(value)) > -1) || `Value must be a non-negative integer`,
            modRequired: (alarmMod) => ((!!alarmMod.modif_disregard || !!alarmMod.modif_change_severity || !!alarmMod.modif_text || !!alarmMod.modif_clear_iff_acked || !!alarmMod.modif_clear_never ||
                !!alarmMod.modif_clear_after_min || !!alarmMod.modif_service_affecting || !!alarmMod.modif_shakeout) || 'You must specifiy how to modify the alarm'),
            alarmStepForm: (form) => ((form === undefined || form.validate()) || false),
        },
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111',
        },
        dpProps: {
            color: '#c42111',
        },
        tfProps: {},
        showTimeLimited: true
    }),

    computed: {
        locale: {
            get: function() {
                let arr = this.$props.alarmMod.modif_locale.split('|');
                return arr[0] !== "" ? arr : null;
            },
            set: function(selectedLocales) {
                this.$props.alarmMod.modif_locale = selectedLocales.join('|');
            }
        },

        severity: {
            get: function() {
                let arr = this.$props.alarmMod.modif_orig_severity.split('|');
                return arr[0] !== "" ? arr : null;
                return this.$props.alarmMod.modif_orig_severity.split('|');
            },
            set: function(selectedSeverities) {
                this.$props.alarmMod.modif_orig_severity = selectedSeverities.join('|');
            }
        },
    },

    methods: {
        okClicked: function() {
            if(this.$refs.alarmParamsForm.validate() && this.$refs.alarmModForm.validate() && this.$refs.ruleDetailsForm.validate()) {
                if(!!this.$props.alarmMod.modif_active_starting && !!this.$props.alarmMod.modif_active_until) {
                    this.$props.alarmMod.modif_active_starting = TELSA.moment(this.$props.alarmMod.modif_active_starting).format('YYYY-MM-DD HH:mm:ss');
                    this.$props.alarmMod.modif_active_until = TELSA.moment(this.$props.alarmMod.modif_active_until).format('YYYY-MM-DD HH:mm:ss');
                }
                this.$emit('ok');
            }
        },

        clearDates: function(value) {
            if(value === false) {
                this.$props.alarmMod.modif_active_starting = null;
                this.$props.alarmMod.modif_active_until = null;
                this.showTimeLimited = false;
                this.$nextTick(() => {
                    this.showTimeLimited = true;
                });
            }
        }
    },

    created() {
        let self = this;
        let timeLimitedValidation = function() {
            return self.timeLimited ? ((!!self.$props.alarmMod.modif_active_starting && !!self.$props.alarmMod.modif_active_until) || 'Required') : true;
        }
        this.tfProps = {rules: [timeLimitedValidation]};
    },

    mounted() {
        this.timeLimited = (!!this.$props.alarmMod.modif_active_starting && !!this.$props.alarmMod.modif_active_until);
    },

    watch: {
    },


};
</script>

<style scoped>

    .stepper {
        background: #424242; 
        height: calc(100vh - 126px);
    }
    .stepper .stepper-step {
        padding: 12px 24px;
    }
    .stepper-content-container {
        overflow-y: auto;
        height: calc(100% - 55px); 
    }
    .stepper-content {
        /* padding: 16px 4px 4px 4px; */
    }

    .data-container {
        padding: 0;
    }

    .week-day {
        display: inline-block;
        margin-right: 3em;
    }

    .week-day-label {
        display: block;
        font-weight: bold;
    }

</style>
